import { render } from "./FloorTypeEditing.vue?vue&type=template&id=86572510&ts=true"
import script from "./FloorTypeEditing.vue?vue&type=script&lang=ts"
export * from "./FloorTypeEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__